module.exports = __webpack_public_path__ + "static/media/b-social-yelp.8dce7b2a.png";